import Model from "@/api/Model";

class SetToggleHide extends Model {
    buildUrl(request) {
        return ['stock/products', request.param,'toggle-hide'];
    }
};

export default new SetToggleHide;